import {Link} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {useBranding} from '../../app/core/BrandingProvider';

export const MaintenancePage = () => {
  const {organization} = useBranding();

  return (
    <div className='card-body py-15 py-lg-20 text-center'>
      {/* begin::Title */}
      <h1 className='fw-bolder text-gray-900 mb-5'>System Under Maintenance!</h1>
      {/* end::Title */}

      <div className='fs-5 mb-4'>
        <span className='fw-semibold text-gray-700'>
          {organization?.maintenance_page_text ||
            "We are currently performing scheduled maintenance to improve our system's performance and reliability."}
        </span>
      </div>

      {/* begin::Illustration */}
      <div className='mb-0'>
        <img
          src={require("./maintenance.png")}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      <div className='mb-11'>
        <Link to='/auth/login' className='btn btn-sm btn-primary'>
          Login to App
        </Link>
      </div>
    </div>
  );
};
